import { Separator } from 'components';
import { BottomContainer } from '../index';

export const NativeTab = ({ isNewCreative }) => {
  return (
    <>
      <Separator marginTop='32px' />
      <BottomContainer isNewCreative={isNewCreative} />
    </>
  );
};
